import React, { useState, useEffect }  from 'react';
import styled from 'styled-components/macro';

const SwagRow = styled.div`
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 16px;
  margin: 16px;
  height: 132px;

  & img {
    height: 100px;
    float: left;
  }

  & .Swag-price {
    font-weight: bold;
    font-size: 140%;
  }
`;

const Swag = ({info}) => {
  console.log("err?", info);
  return(
  <SwagRow>
    <img src={"https://arcane-caverns-09499.herokuapp.com/" + (info && info.image)} alt="" />
    <h4>{info && info.name}</h4>
    <p>{info && info.price}</p>
  </SwagRow>
)};

const Swags = () => {
  const [hats, setHats] = useState([])
  useEffect(() => {
    fetch("https://arcane-caverns-09499.herokuapp.com/get-swags")
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const topArray = Object.keys(data['hat']).map(function(k) { return data['hat'][k] });
        const midArray = Object.keys(data['top']).map(function(k) { return data['top'][k] });
        const botArray = Object.keys(data['shoes']).map(function(k) { return data['shoes'][k] });
        console.log(botArray);
        setHats(topArray.concat(midArray).concat(botArray));
      });
  }, []);

  return(
    <>
      {hats.map((el, idx) => <Swag info={el} key={idx} />)}
    </>
  )
};

export default Swags;
